import { configureStore, Store } from '@reduxjs/toolkit';
import { claimReducer } from './claim/claimSlice';
import { termsAndConditionsReducer } from './termsAndConditions/termsAndConditionsSlice';
import { vestingInfoReducer } from './vestingInfo/vestingInfoSlice';

export const store: Store = configureStore({
  reducer: {
    vestingInfo: vestingInfoReducer,
    claim: claimReducer,
    termsAndConditions: termsAndConditionsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          jwt: ''
        }
      }
    })
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
